import React from 'react';
import Experts from './Experts/Experts';
import CheckList from 'commonComponents/CheckList/CheckList';
import styles from './InfoBar.module.scss';

const InfoBar = ({ title, experts, list }) => {
  return (
    <div className={ styles.InfoBar }>
      <h3 className={ styles.title }>{ title }</h3>
      <Experts experts={ experts } />
      <hr />
      { list && <CheckList list={ list } type="big" /> }
    </div>
  );
};

export default InfoBar;
